import { render } from "./textaPendulumXinJiang.vue?vue&type=template&id=5d76ca0f&scoped=true"
import script from "./textaPendulumXinJiang.vue?vue&type=script&lang=js"
export * from "./textaPendulumXinJiang.vue?vue&type=script&lang=js"

import "./textaPendulumXinJiang.vue?vue&type=style&index=0&id=5d76ca0f&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d76ca0f"]])

export default __exports__